import { Reveal } from './Reveal';

export const Cambios = () => (
    <section className="py-20 px-6" data-testid="cambios-section">
        <div className="max-w-[640px] mx-auto">
            <Reveal className="text-center">
                <h2 className="font-serif font-normal text-[clamp(1.9rem,4vw,2.6rem)] text-ink mb-10" data-testid="cambios-title">
                    Mis <span className="italic text-roselight">cambios</span>
                </h2>
            </Reveal>
            <Reveal delay={0.05}>
                <p className="text-[#4A4744] font-light leading-relaxed mb-10" data-testid="cambios-texto-1">
                    Durante estos 6 años entrenando he podido ver el cambio físico que he logrado. No ha sido un
                    proceso perfecto, y mucho menos rápido. Hay días en los que no tengo ganas, días en los que me
                    cuesta más y momentos en los que siento que no veo ningún avance o me siento frustrada. Pero es
                    justo ahí donde he aprendido a ser paciente con mi proceso, a confiar en el camino y recordar
                    que no todos los cambios se ven de un día para otro.
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <div className="flex flex-wrap justify-center gap-5 mb-10">
                    {[
                        { src: '/mi-cambio-fisico.webp', testid: 'cambio-fisico-foto' },
                        { src: '/mi-cambio-fisico-2.webp', testid: 'cambio-fisico-foto-2' },
                    ].map((f) => (
                        <figure key={f.src} data-testid={f.testid} className="group w-[240px] md:w-[260px]">
                            <div className="overflow-hidden rounded-[20px] border border-ink/10 shadow-[0_2px_24px_rgba(20,20,20,0.08)]">
                                <img
                                    src={f.src}
                                    alt="Mi cambio físico — antes y después"
                                    className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
                                />
                            </div>
                        </figure>
                    ))}
                </div>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="text-[#4A4744] font-light leading-relaxed" data-testid="cambios-texto-2">
                    Con el tiempo también aprendí que llevar un estilo de vida saludable no significa prohibirte
                    todo lo que disfrutas. Amo comer, amo cocinar y amo los postres, y no quiero dejar de disfrutar
                    esas cosas por llevar un estilo de vida perfecto e impecable. Para mí encontrar un equilibrio
                    también forma parte de cuidar de mí misma. Entreno, me esfuerzo y persigo mis objetivos, pero
                    también disfruto de un gusto cuando quiero, sin sentir que tengo que castigarme por hacerlo.
                </p>
            </Reveal>
        </div>
    </section>
);
